/* eslint-disable */
// @ts-nocheck
import * as Types from '@xing-com/crate-common-graphql-types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type GetLoggedOutQueryPollResultQueryVariables = Types.Exact<{
  backgroundJobId: Types.Scalars['String']['input'];
}>;

export type GetLoggedOutQueryPollResultQuery = {
  __typename?: 'Query';
  fabiJobSearchLoggedOutQueryGenerationPoll?: {
    __typename: 'FabiJobSearchLoggedOutQueryGenerationPollResponse';
    status: Types.FabiBackgroundJobStatus;
  } | null;
};

export const GetLoggedOutQueryPollResultDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetLoggedOutQueryPollResult' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'backgroundJobId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'fabiJobSearchLoggedOutQueryGenerationPoll',
            },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'backgroundJobId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'backgroundJobId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetLoggedOutQueryPollResultQuery,
  GetLoggedOutQueryPollResultQueryVariables
>;
